import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription, Subject } from 'rxjs/Rx';

import { startOfDay, endOfDay, subDays, addDays, endOfMonth, isSameDay, isSameMonth, addHours } from 'date-fns';
import { CalendarEvent, CalendarEventAction, CalendarEventTimesChangedEvent, CalendarView } from 'angular-calendar';

import { Home } from '../home';
import { CalendarService } from './service/calendar.service';
import { EventModel } from './model/event.model';
import { CalendarEventActionsComponent } from 'angular-calendar/modules/common/calendar-event-actions.component';
import { analyzeAndValidateNgModules } from '@angular/compiler';

declare var $: any;

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent extends Home implements OnInit {

  @ViewChild('f') form;

  CalendarView: any = CalendarView;
  view: CalendarView;
  viewDate: Date;
  events: Array<CalendarEvent>;
  refresh: Subject<any>;
  activeDayIsOpen: boolean;
  locale: string = 'pt-BR';

  commons: any;
  eventModels: any;

  get: Subscription;
  dropdown: Subscription;
  post: Subscription;
  del: Subscription;

  constructor(private router: Router, public eventModel: EventModel, private calendarService: CalendarService) {
    super(router);
  }

  ngOnInit() {
    this.list();
    this.listCommon();
    this.view = CalendarView.Month;
    this.viewDate = new Date();
    this.refresh = new Subject();
    this.activeDayIsOpen = false;
  }

  list() {
    this.get = this.calendarService.get()
      .subscribe(succ => {
        let ret: any = succ;

        if (ret.success) {
          this.eventModels = ret.items;
          this.events = new Array<CalendarEvent>();

          this.eventModels.forEach(e => {
            this.events.push({
              start: new Date(e.date),
              title: e.name,
              color: { primary: e.common.color, secondary: e.common.color }
            });
          });
          this.refresh.next();
        }
      },
        err => {
          console.log(err);
          this.allowAcess(err.status);
        });
  }

  listCommon() {
    this.dropdown = this.calendarService.dropdown('common')
      .subscribe(succ => {
        let ret: any = succ;

        if (ret.success) {
          this.commons = ret.items;
        }
      },
        err => {
          console.log(err);
          this.allowAcess(err.status);
        });
  }

  modalData: {
    action: string;
    event: CalendarEvent;
  };

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    this.eventModel.date = date;
    this.eventModel.datef = date;
    $('#myModal').modal('show');
  }

  handleEvent(action: string, event: CalendarEvent): void {
    this.modalData = { event, action };
  }

  doEvent(eventModel, valid) {

    if (!valid) return;

    this.doCreated(eventModel);

  }

  doCreated(e) {
    this.post = this.calendarService.post(e)
      .subscribe(succ => {
        let ret: any = succ;

        if (ret.success) {
          this.list();
          $('#myModal').modal('hide');
          this.openMessenge('Registro cadastrado com sucesso.', 'success');
          this.clean();
          this.list();
        } else {
          this.openMessenge(ret.messege, 'danger');
        }
      },
        err => {
          console.log(err);
          this.openMessenge('Não foi possivel concluir a operação.', 'danger');
          this.allowAcess(err.status);
        });
  }

  doRemove(id) {
    this.del = this.calendarService.del(id)
      .subscribe(succ => {
        let ret: any = succ;

        if (ret.success) {
          this.list();
        }
      },
        err => {
          console.log(err);
          this.allowAcess(err.status);
        });
  }

  clean() {

  }
}